/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_TitleInputs */

const en_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align Center`)
};

const fr_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner au Centre`)
};

const de_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentrieren`)
};

const it_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea al centro`)
};

const ru_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выровнять по центру`)
};

const es_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear al centro`)
};

const zh_cn2_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居中对齐`)
};

const ja_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央揃え`)
};

const hi_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्य में संरेखित करें`)
};

const pt_pt2_align_center_title = /** @type {(inputs: Align_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de alinhamento`)
};

/**
* | output |
* | --- |
* | "Align Center" |
*
* @param {Align_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_title = /** @type {((inputs?: Align_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_center_title(inputs)
	if (locale === "de") return de_align_center_title(inputs)
	if (locale === "it") return it_align_center_title(inputs)
	if (locale === "ru") return ru_align_center_title(inputs)
	if (locale === "es") return es_align_center_title(inputs)
	if (locale === "zh-CN") return zh_cn2_align_center_title(inputs)
	if (locale === "ja") return ja_align_center_title(inputs)
	if (locale === "hi") return hi_align_center_title(inputs)
	if (locale === "pt-PT") return pt_pt2_align_center_title(inputs)
	return en_align_center_title(inputs)
});